import { Observable } from 'rxjs';

import { Model, ModelQueryParams, ModelsCreateParams, ModelsExtract, ModelsExtractParams } from '../models/model.model';
import { ListResponse } from '../models/utility.model';

export abstract class ModelGateway {
  abstract listModels(params: ModelQueryParams): Observable<ListResponse<Model>>;
  abstract listExtractModels(params: ModelsExtractParams): Observable<ListResponse<ModelsExtract>>;
  abstract createModels(params: ModelsCreateParams): Observable<ListResponse<Model>>;
  abstract deleteModel(modelId: string): Observable<void>;
}
